import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div>
      <footer className="" style={{paddingTop:"25px"}}>
        <div className="container">
          <div className="row mb-n7">
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                <a className="footer-brand" href="#">
                  <img width={170} src="/assets/images/logo/Vaishnavi.png" alt="images_not_found" />
                </a>
                
                <ul className="footer-des">

                  <li className="footer-des-list">
                    <i className="las la-envelope-open" />
                    <a href="mailto:demo@hasthemes.com">vaishnavithekua@gmail.com</a>
                  </li>
                  <li className="footer-des-list">
                    <i className="las la-phone-volume" />
                    <a href="tel:+11238889999">+91 82694 62169</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                {/* <ul className="footer-menu">
                  <li className="footer-menu-items">
                    <Link className="footer-menu-link" to={"/shop"}>Products</Link>
                  </li>
                  <li className="footer-menu-items">
                    <Link className="footer-menu-link" to={"/login"}>Login</Link>
                  </li>
                </ul> */}
              </div>
            </div>
            
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                {/* <h4 className="title">Information</h4> */}
                <ul className="footer-menu">
                  <li className="footer-menu-items">
                    <Link className="footer-menu-link" to="/aboutus">About Us</Link>
                  </li>
                  <li className="footer-menu-items">
                    <Link className="footer-menu-link" to={"/terms-conditions"}>Terms & Conditions</Link>
                  </li>
                  <li className="footer-menu-items">
                    <Link className="footer-menu-link" to={"/privacy-policy"}>Privacy & Policy</Link>
                  </li>

                  {/* <li className="footer-menu-items">
                    <Link className="footer-menu-link" to={"/contect_us"}>Contact Us</Link>
                  </li> */}
                  
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                {/* <h4 className="title">Information</h4> */}
                <div className="social-links social-links-dark">
                  <a className="social-link facebook" href="https://www.facebook.com/people/Vaishnavi-Thekua/61584892635017/?rdid=awPtJi9C92T5KXSh&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Fr5skszT6%2F"><i className="lab la-facebook" /></a>
                                    <a className="social-link instagram" href="https://www.instagram.com/vaishnavithekuaa?igsh=ajkzY2g4ZXpwMGE3&utm_source=ig_contact_invite"><i className="lab la-instagram" /></a>
                  <a className="social-link youtube" href="https://youtube.com/@vaishnavithekua?feature=shared"><i className="lab la-youtube" /></a>

                  {/* <a className="social-link twitter" href="https://x.com/"><i className="lab la-twitter" /></a> */}
                </div>
                {/* <a className="footer-payment" href="#">
                  <img src="/assets/images/payment/payment.png" alt="images_not_found" />
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="copy-right bg-dark">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <p>
                  © <span id="currentYear" /> Made With
                  <i className="las la-heart" /> By
                  <a href="https://vaishnavithekua.com/">Vaishnavi Thekua</a>
                  All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
